// src/utils/analytics.ts
import ReactGA from 'react-ga4';

/**
 * Inicializa o GA4 com o Measurement ID da variável de ambiente.
 */
export const initGA = (): void => {
  const id = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!id) {
    console.warn('[Analytics] REACT_APP_GA_MEASUREMENT_ID não definida');
    return;
  }
  ReactGA.initialize(id);
};

/**
 * Envia página para GA4.
 * @param path current pathname + search (ex: "/home?ref=utm")
 */
export const logPageView = (path: string): void => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

/**
 * Ajuste aqui:
 * - Recebemos um objeto com action e params opcionais.
 * - Chamamos ReactGA.event(nomeDaAção, parâmetros).
 */
export const logEvent = (opts: {
  action: string;
  category?: string;
  label?: string;
  value?: number;
}): void => {
  const { action, category, label, value } = opts;
  ReactGA.event(action, { category, label, value });
};